import { Button } from '@innovyze/stylovyze';
import SyncIcon from '@mui/icons-material/Sync';
import React from 'react';
import {
	Label,
	LabelBold,
	StyledContainer,
} from './ComponentStatusControls.styles';
import { Grid } from '@mui/material';
import formatDateTime from '@Utils/formatDateTime';

export type ComponentStatusControlsProps = {
	clickOnSynchButtonHandler: () => void;
	lastSynchAtTs: number;
	dateLabel: string;
	syncButtonText: string;
	format: string;
	timeZoneIANA: string;
	disabledSync: boolean;
};

const ComponentStatusControls = (props: ComponentStatusControlsProps) => {
	const {
		clickOnSynchButtonHandler,
		lastSynchAtTs,
		dateLabel,
		syncButtonText,
		format,
		timeZoneIANA,
		disabledSync,
	} = props;

	const syncDateText = formatDateTime(
		new Date(lastSynchAtTs),
		timeZoneIANA,
		format,
	);

	return (
		<StyledContainer>
			<Grid
				container
				direction="column"
				justifyContent="flex-start"
				alignItems="flex-end">
				<LabelBold>{dateLabel}</LabelBold>
				<Label>{syncDateText}</Label>
			</Grid>
			<Button
				data-cy="synch-status"
				color={'primary'}
				variant="outlined"
				onClick={clickOnSynchButtonHandler}
				disabled={disabledSync}>
				<>
					<SyncIcon />
					{syncButtonText}
				</>
			</Button>
		</StyledContainer>
	);
};

export default ComponentStatusControls;
